import { render } from "./SpaceFormPageThree.vue?vue&type=template&id=8d057452"
import script from "./SpaceFormPageThree.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageThree.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "8d057452"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d057452', script)) {
    api.reload('8d057452', script)
  }
  
  module.hot.accept("./SpaceFormPageThree.vue?vue&type=template&id=8d057452", () => {
    api.rerender('8d057452', render)
  })

}

script.__file = "src/components/dashboard/space-form-pages/SpaceFormPageThree.vue"

export default script